import { useTitle as AHUseTitle } from 'ahooks';

const useTitle = (title: string, prefix = true) => {
  const newTitle = prefix ? `Cobli - ${title}` : title;
  return AHUseTitle(newTitle);
};

export default useTitle;
